<!-------------------------------- View ----------------------------------->
<div class="dialog-content-max">
    <form [formGroup]="esignForm">

        <div class="formgrid grid">
            <div class="field col-4">
                <div class="form-group">
                    <label for="module" class="required-label">Module</label>
                    <input type="text" class="form-control" formControlName="module" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="esignid" class="required-label">ESign ID</label>
                    <input type="text" class="form-control" formControlName="esignid" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="transid" class="required-label">Trans ID</label>
                    <input type="text" class="form-control" formControlName="transid" [readonly]="true" />
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-4">
                <div class="form-group">
                    <label for="uuid" class="required-label">UUID</label>
                    <input type="text" class="form-control" formControlName="uuid" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="createdon" class="required-label">Created On</label>
                    <input type="text" class="form-control" formControlName="createdon" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="createdby" class="required-label">Created By</label>
                    <input type="text" class="form-control" formControlName="createdby" [readonly]="true" />
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-4">
                <div class="form-group">
                    <label for="doctype" class="required-label">Document Type</label>
                    <input type="text" class="form-control" formControlName="doctype" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="signtype" class="required-label">Signature Type</label>
                    <input type="text" class="form-control" formControlName="signtype" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="signseq" class="required-label">Signature Sequence</label>
                    <input type="text" class="form-control" formControlName="signseq" [readonly]="true" />
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-4">
                <div class="form-group">
                    <label for="signpage" class="required-label">Signature Page</label>
                    <input type="text" class="form-control" formControlName="signpage" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="numberofsigns" class="required-label">Number of Signatures</label>
                    <input type="text" class="form-control" formControlName="numberofsigns" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="ctr" class="required-label">Number Signed</label>
                    <input type="text" class="form-control" formControlName="ctr" [readonly]="true" />
                </div>
            </div>
        </div>


        <div class="formgrid grid">
            <div class="field col-4">
                <div class="form-group">
                    <label for="closeddate" class="required-label">Closed Date</label>
                    <input type="text" class="form-control" formControlName="closeddate" [readonly]="true" />
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-12">
                <div class="form-group">
                    <label for="pdffilename" class="required-label">Original File Name</label>
                    <input type="text" class="form-control" formControlName="pdffilename" [readonly]="true" />
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-12">
                <div class="form-group">
                    <label for="esignid" class="required-label">Final Signed File</label>
                    <input type="text" class="form-control" formControlName="finals3signeddocument" [readonly]="true" />
                </div>
            </div>

        </div>






        <span layout="row">
            <hr flex />
        </span>
        <br />

        <!-- REMARKS -->

        <div class="formgrid grid">
            <div class="field col-12 sm:col-12 lg:col-12">
                <p-card *ngIf="EsignotherDetails.length>0">
                    <p-table [value]="EsignotherDetails" [rowHover]="true">
                        <ng-template pTemplate="header">
                            <tr>
                                <th width="20%">Name</th>
                                <th width="30%">Email</th>
                                <th width="10%">Order</th>
                                <th width="10%">Position</th>
                                <th width="10%">Signed?</th>
                                <th width="15%">Signed On</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-data let-i="rowIndex">
                            <tr>
                                <td>{{data.name}}</td>
                                <td>{{ data.email }}</td>
                                <td>{{ data.orderofsign }}</td>
                                <td>{{ data.positionofsign }}</td>
                                <td>{{ data.issigned }}</td>
                                <td>{{ data.signeddate }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-card>
            </div>

            <div class="custom-dialog-footer">
                <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
            </div>

        </div>